import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { StringerAllocationUI } from "./StringerAllocationUI";

export function StringerAllocationModal({ onSuccess }: { onSuccess?: () => void }) {
  const { currentUser } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [stringers, setStringers] = useState<any[]>([]);
  const [availablePoints, setAvailablePoints] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const API_URL = import.meta.env.VITE_API_URL;

  const getAuthHeader = () => {
    const token = localStorage.getItem("tt_auth_token");
    const headers: Record<string, string> = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
  };

  useEffect(() => {
    if (currentUser?.role === "ADMIN") {
      fetchAllocations();
    }
  }, [currentUser]);

  const fetchAllocations = async () => {
    try {
      const res = await fetch(`${API_URL}/api/settings/stringer-allocation`, {
        headers: getAuthHeader(),
      });
      if (res.ok) {
        const data = await res.json();
        setAvailablePoints(data.availablePoints || []);
        setStringers(data.stringers || []);
        
        const today = new Date().toISOString().split("T")[0];
        const lastDate = data.lastAllocationDate ? data.lastAllocationDate.split("T")[0] : null;
        
        if (lastDate !== today) {
          setIsOpen(true);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePointChange = (stringerId: string, point: string) => {
    setStringers(prev => prev.map(s => {
      if (s.id === stringerId) {
        const currentPoints = s.stringingPoints || [];
        const newPoints = currentPoints.includes(point) 
          ? currentPoints.filter((p: string) => p !== point) 
          : [...currentPoints, point];
        return { ...s, stringingPoints: newPoints };
      }
      return s;
    }));
  };

  const handleSave = async () => {
    try {
      const res = await fetch(`${API_URL}/api/settings/stringer-allocation`, {
        method: "POST",
        headers: {
          ...(getAuthHeader() as any),
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ allocations: stringers })
      });
      if (res.ok) {
        setIsOpen(false);
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao salvar.");
    }
  };

  if (!isOpen || loading || currentUser?.role !== "ADMIN") return null;

  return (
    <StringerAllocationUI
      stringers={stringers}
      availablePoints={availablePoints}
      onPointChange={handlePointChange}
      onSave={handleSave}
      onSkip={() => setIsOpen(false)}
      isModal={true}
    />
  );
}
